import React, { useContext, useEffect, useRef, useState } from 'react';
import { Context_UI } from '../../Contexts/Context_UI';
import { useAuth } from '../../Contexts/AuthContext';
import { Templates_Get_All, Templates_Initialize, Templates_Update } from '../../api/API_Templates'
import { useTemplating } from '../../Contexts/Context_Templating';
import { useScheduleManagement } from '../../Contexts/Context_ScheduleManagement';
import { useAccounts } from '../../Contexts/Context_Accounts';
import Document_Header from '../../Assets/Images/Form_Header.png';

export default function Document_Preview({
    Type,
    Subtitle,
    Orientation,
    Page,
    Page_Total,
    children
}) {
    const { Account, Loading } = useAuth();
    const UI = useContext(Context_UI);
    const { Time_Parse } = useScheduleManagement();
    const { User } = useAccounts();

    const Now = new Date();

    // const [Pages, Pages_Set] = useState([]);
    // const Ref_Container = useRef();

    // useEffect(() => {
    //     const Content = Ref_Container.current;
    //     if (!Content) { return; }
    //     const Paper_Height = 816;
    //     const Page_Nodes = [];
    //     let Page_Current = document.createElement("div");
    //     Page_Current.classList.add("Document_Paper");

    //     let Paper_Height_Current = 0;

    //     Array.from(Content.children).forEach((Child) => {
    //         const Child_Height = Child.scrollHeight;
    //         if (Paper_Height_Current + Child_Height > Paper_Height) {
    //             Page_Nodes.push(Page_Current);
    //             Page_Current = document.createElement("div");
    //             Page_Current.classList.add("Document_Paper");
    //             Paper_Height_Current = 0;
    //         }

    //         Page_Current.appendChild(Child.cloneNode(true));
    //         Paper_Height_Current += Child_Height;
    //     });

    //     if (Page_Current.children.length > 0) {
    //         Page_Nodes.push(Page_Current);

    //         Pages_Set(Page_Nodes.map((Node) => Node.outerHTML));
    //     }
    // }, [children])


    if (Loading) {
        return null;
    }
    return (
        <>
            <div className='Document'>
                <div
                    className='Document_Paper'
                    id={`Document_Paper_${Page}`}
                    Type={`Letter_${Orientation ? Orientation : "Portrait"}`}
                    Orientation={Orientation}
                >
                    <div className='Document_Header'>
                        <img src={Document_Header} draggable='false' loading='lazy' className='Document_Header_Logo' />
                        <div className='Document_Header_Title'>
                            <h2 className='Document_Title'>
                                General Services Unit
                            </h2>
                            {Type ?
                                <h3 className='Document_Type'>
                                    {Type}
                                </h3>
                                :
                                ""
                            }
                            {Subtitle ?
                                <p className='Document_Subtitle'>
                                    {Subtitle}
                                </p>
                                :
                                ""
                            }
                        </div>
                    </div>
                    <div className='Document_Content'>

                        {children}
                    </div>
                    <div className='Document_Footer'>
                        <p className='Document_Footer_Text'>
                            Document generated {Time_Parse(Now)} by {User?.Name_Compounded}
                        </p>
                        <p className='Document_Footer_Page'>
                            Page {Page} of {Page_Total}
                        </p>
                    </div>
                </div>
                {/* {Pages.length === 0 ?
                    
                    :
                    <>
                        {Pages.map((HTML, Index) => (
                            <div
                                key={Index}
                                className='Document_Paper'
                                dangerouslySetInnerHTML={{ __html: HTML }}
                            />
                        ))}
                    </>
                } */}

            </div>
        </>
    );
}
